import { render, staticRenderFns } from "./fullnotices.vue?vue&type=template&id=12fe3e8a&"
import script from "./fullnotices.vue?vue&type=script&lang=js&"
export * from "./fullnotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports